import {
  Dropdown,
  Icon,
  IconButton,
  IDropdownOption,
  // IDropdownProps, //Fix Warning Complaint Code:071225
  // ISelectableOption, //Fix Warning Complaint Code:071225
  PrimaryButton,
  TooltipHost,
} from "@fluentui/react";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppRoutes } from "../../Constants/AppRoutes";
import { IAlarm, isTestAlarm, testAlarmNote } from "../../Models/IAlarm";
import TestBadge from "../TestBadge/TestBadge";
// import { ISensor } from "../../Models/ISensor"; //Fix Warning Complaint Code:071225
import { GlobalState } from "../../Redux/RootReducer";
import { IAPIResponse } from "../../Services/AjaxService";
import ApiService from "../../Services/ApiService";
import {
  getSensorIconName,
  getSensorIconTooltip,
} from "../../Utils/SensorMaps";
import IconButtonItem from "../IconButtonItem/IconButtonItem";
import VideoFrame from "../VideoFrame/VideoFrame";
import ReactHowler from "react-howler";
import "./AlarmGalleryHandler.scss";
import { ToastMessage } from "../../Utils/UIMessages";
import SettingsUtil from "../../Utils/Settings";
import { DEFAULT_VIDEO_SIZES } from "../../Pages/OptionsPage/OptionsPage";
// import { JSONPrint } from "../../Utils/Generic"; //Fix Warning Complaint Code:071225
import { GetProcessParam } from "../../Utils/ProcessParams";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import audioUtil from "../../Utils/AudioService";
import WalkieTalkieControls from "../WalkieTalkieControls/WalkieTalkieControls";
import walkieTalkieTimer from "../../Utils/WalkieTalkieTimer";
import { WalkieTalkieActions } from "../../Redux/WalkieTalkie/WalkieTalkieAction";
import { AppConfig, getEnvVar, isWebSocketEnabled, isPollingEnabled, getAlarmPollingInterval } from "../../Config/AppConfig";
import WebSocketService from "../../Services/WebSocketService";
// import { IRole } from "../../Models/IRole"; //Fix Warning Complaint Code:071225

const devDisablePoll: any = false;

// Funzioni per gestire la persistenza degli allarmi mutati
const MUTED_ALARMS_KEY = 'mutedAlarms';

const saveMutedAlarm = (alarmId: number) => {
  const mutedAlarms = getMutedAlarms();
  if (!mutedAlarms.includes(alarmId)) {
    mutedAlarms.push(alarmId);
    localStorage.setItem(MUTED_ALARMS_KEY, JSON.stringify(mutedAlarms));
  }
};

const getMutedAlarms = (): number[] => {
  const stored = localStorage.getItem(MUTED_ALARMS_KEY);
  return stored ? JSON.parse(stored) : [];
};

const removeMutedAlarm = (alarmId: number) => {
  const mutedAlarms = getMutedAlarms().filter(id => id !== alarmId);
  localStorage.setItem(MUTED_ALARMS_KEY, JSON.stringify(mutedAlarms));
};

const isAlarmMuted = (alarmId: number): boolean => {
  return getMutedAlarms().includes(alarmId);
};

export interface IAlarmRefertOption {
  label: string;
  small?: string;
}

const refertOptionsDefault: IAlarmRefertOption[] = [
  { label: "Caduto fuori dal letto" },
  { label: "In piedi fuori dal letto" },
  { label: "Seduto sul letto" },
  { label: "Si agita nel letto" },
  { label: "Urla & caduto dal letto" },
  { label: "Urla & in piedi fuori dal letto" },
  { label: "Urla & seduto sul letto" },
  { label: "Urla & si agita nel letto" },
  { label: "Porta aperta" },
];
const getRefertOptions = () => {
  const refertOptionsFromParams: string | undefined = GetProcessParam(
    "REACT_APP_API_REFERT_OPTIONS"
  );
  const refertOptionsFromParamsProcessed: string[] = refertOptionsFromParams
    ? JSON.parse(refertOptionsFromParams)
    : [];

  const refertOptionsProcessed: IAlarmRefertOption[] =
    refertOptionsFromParamsProcessed.length > 0
      ? refertOptionsFromParamsProcessed.map((x: string) => {
          return {
            label: x,
          };
        })
      : refertOptionsDefault;

  let baseOptionsVector: IAlarmRefertOption[] = [
    { label: "Allarme rientrato", small: "(intervento non necessario)" },
  ];

  for (let i = 0; i < refertOptionsProcessed.length; i++) {
    baseOptionsVector.push(refertOptionsProcessed[i]);
  }

  return baseOptionsVector;
};

export interface IAlarmTileVoice {
  enabled: boolean;
  type: string;
  // tutti gli allarmi di questo sensore sono di prova
  isTest?: boolean;
}

const AlarmGallerySensorTile = (props: IAlarmTileVoice) => {
  return (
    <div className={"gallery-sensor-tile-outer"}>
      {props.enabled && (
        <div
          className={
            "gallery-sensor-tile " +
            (props.enabled ? "gallery-sensor-tile-active" : "")
          }
        >
          <Icon iconName={getSensorIconName(props.type)} />
          <div className="gallery-sensor-tile-title">
            {getSensorIconTooltip(props.type)}
          </div>
          {props.isTest && <TestBadge />}
        </div>
      )}
    </div>
  );
};

export interface IAlarmGalleryModalProps {
  alarms: IAlarm[];
  onAlarmHandled: (alarmId: number) => void;
  isFirstAlarm?: boolean;
}

const AlarmGalleryModal = (props: IAlarmGalleryModalProps) => {
  const refertOptions: IAlarmRefertOption[] = getRefertOptions();
  const navigate = useNavigate();
  const [alarms, setAlarms] = useState<IAlarm[]>([]);
  // Inizializza playSound controllando se l'allarme è già stato mutato
  const [playSound, setPlaySound] = useState<boolean>(() => {
    // Se ci sono allarmi, controlla se almeno uno non è mutato
    if (props.alarms.length > 0) {
      return !props.alarms.every(alarm => isAlarmMuted(alarm.id));
    }
    return true;
  });
  const [alarmBorder, setAlarmBorder] = useState<boolean>(true);
  const [processing, setProcessing] = useState<boolean>(false);
  const [refertReason, setRefertReason] = useState<string>();
  const [sentineId, setSentinelId] = useState<number>(-1);
  const [alarmHandle, setAlarmHandle] = useState<NodeJS.Timeout | null>(null);
  // const [requestedAudioOnAlarm, setRequestedAudioOnAlarm] = useState<boolean>(false); //Fix Warning Complaint Code:071225
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const [sceneClipUrl, setSceneClipUrl] = useState<string | null>(null);
  const [loadingScene, setLoadingScene] = useState<boolean>(false);
  const [sceneMode, setSceneMode] = useState<boolean>(false);
  const [preloadingScene, setPreloadingScene] = useState<boolean>(false);
  const dispatch = useDispatch();

  const formatDate = () => {
    let isoDate: string = alarms[0].createdAt;
    return isoDate.split("T")[0] + " " + new Date(isoDate).toLocaleTimeString();
  };

  const alarmTimeoutOn = () => {
    setAlarmBorder(true);
    setAlarmHandle(
      setTimeout(() => {
        alarmTimeoutOff();
      }, 1000)
    );
  };

  const alarmTimeoutOff = () => {
    setAlarmBorder(false);
    setAlarmHandle(
      setTimeout(() => {
        alarmTimeoutOn();
      }, 1000)
    );
  };

  useEffect(() => {
    setAlarms(props.alarms ?? []);
  }, [props.alarms]);

  const silence = () => {
    setPlaySound(false);
  };

  const closeVideoStream = () => {
    setShowVideo(false);
    setSceneMode(false);
  };

  // Funzione per precaricare la scena in background
  const preloadScene = async () => {
    if (preloadingScene || sceneClipUrl) {
      return; // Già in caricamento o già caricato
    }
    
    setPreloadingScene(true);
    console.log('🎬 Precaricamento scena in background...');
    
    try {
      const videoSdkHost = AppConfig.videoSdk.host;
      const videoSdkPort = String(AppConfig.videoSdk.port);
      const secondsBefore = parseInt(getEnvVar("REACT_APP_ALARM_CLIP_BEFORE", "30"), 10);
      const secondsAfter = parseInt(getEnvVar("REACT_APP_ALARM_CLIP_AFTER", "180"), 10);
      
      const response = await fetch(
        `http://${videoSdkHost}:${videoSdkPort}/api/nvr/clip-scene`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sentinel_id: alarms[0].sensor.sentinel.id,
            alarm_timestamp: alarms[0].createdAt,
            seconds_before: secondsBefore,
            seconds_after: secondsAfter
          })
        }
      );
      
      if (response.ok) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setSceneClipUrl(url);
        console.log('✅ Scena precaricata con successo');
      } else {
        console.warn('⚠️ Precaricamento scena fallito, verrà caricato al click');
      }
    } catch (error) {
      console.warn('⚠️ Errore precaricamento scena:', error);
    } finally {
      setPreloadingScene(false);
    }
  };

  // Handler per "Visualizza scena" - usa clip precaricato se disponibile
  const handleShowScene = async () => {
    // Se il clip è già stato precaricato, mostralo immediatamente
    if (sceneClipUrl && !preloadingScene) {
      console.log('⚡ Scena già pronta, visualizzazione immediata');
      setSceneMode(true);
      setShowVideo(true);
      ToastMessage('success', 'Clip scena caricato con successo');
      return;
    }
    
    // Se è in corso il precaricamento, aspetta che finisca
    if (preloadingScene) {
      console.log('⏳ Precaricamento in corso, attendi...');
      setLoadingScene(true);
      setSceneMode(true);
      
      // Polling per aspettare che il precaricamento finisca
      const checkInterval = setInterval(() => {
        if (!preloadingScene && sceneClipUrl) {
          clearInterval(checkInterval);
          setLoadingScene(false);
          setShowVideo(true);
          ToastMessage('success', 'Clip scena caricato con successo');
        }
      }, 100);
      
      // Timeout di sicurezza dopo 30 secondi
      setTimeout(() => {
        clearInterval(checkInterval);
        if (loadingScene) {
          setLoadingScene(false);
          ToastMessage('warning', 'Timeout caricamento. Riprova.');
        }
      }, 30000);
      
      return;
    }
    
    // Altrimenti carica normalmente
    setLoadingScene(true);
    setSceneMode(true);
    
    try {
      const videoSdkHost = AppConfig.videoSdk.host;
      const videoSdkPort = String(AppConfig.videoSdk.port);
      const secondsBefore = parseInt(getEnvVar("REACT_APP_ALARM_CLIP_BEFORE", "30"), 10);
      const secondsAfter = parseInt(getEnvVar("REACT_APP_ALARM_CLIP_AFTER", "180"), 10);
      
      const response = await fetch(
        `http://${videoSdkHost}:${videoSdkPort}/api/nvr/clip-scene`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sentinel_id: alarms[0].sensor.sentinel.id,
            alarm_timestamp: alarms[0].createdAt,
            seconds_before: secondsBefore,
            seconds_after: secondsAfter
          })
        }
      );
      
      if (response.ok) {
        // Converti risposta in Blob URL per il tag <video>
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setSceneClipUrl(url);
        setShowVideo(true);
        ToastMessage('success', 'Clip scena caricato con successo');
      } else {
        // FALLBACK: Errore 404/500 → torna a live stream
        const errorData = await response.json();
        console.error('[SCENE] Errore caricamento clip:', errorData);
        ToastMessage('warning', 'Clip non disponibile. Mostrando stream live.');
        
        // Attiva stream live come fallback
        setSceneMode(false);
        setSceneClipUrl(null);
        
        // Chiudi altri stream e attiva live
        document.dispatchEvent(new Event("close-all-video-streams"));
        setTimeout(() => {
          setShowVideo(true);
        }, 100);
      }
    } catch (error) {
      // FALLBACK: Errore di rete → torna a live stream
      console.error('[SCENE] Errore rete:', error);
      ToastMessage('error', 'Errore caricamento scena. Mostrando stream live.');
      
      setSceneMode(false);
      setSceneClipUrl(null);
      
      // Attiva stream live come fallback
      document.dispatchEvent(new Event("close-all-video-streams"));
      setTimeout(() => {
        setShowVideo(true);
      }, 100);
    } finally {
      setLoadingScene(false);
    }
  };

  useEffect(() => {
    const initializeAlarm = () => {
      if (props.alarms.length > 0) {
        setSentinelId(props.alarms[0].sensor.sentinel.id);
        
        const cameraConfigured = props.alarms[0]?.sensor?.sentinel?.cameraUrl && 
                                 props.alarms[0].sensor.sentinel.cameraUrl.trim() !== "";
        
        // Avvia precaricamento scena IMMEDIATAMENTE in background se c'è una camera configurata
        // E se la funzionalità NVR Scene Clip è abilitata
        if (cameraConfigured && AppConfig.nvr.enableSceneClip) {
          preloadScene();
        }
        
        // Se NVR Scene Clip è disabilitato, attiva automaticamente il live stream SOLO sul primo allarme
        if (cameraConfigured && !AppConfig.nvr.enableSceneClip && props.isFirstAlarm) {
          // Chiudi altri stream video attivi
          document.dispatchEvent(new Event("close-all-video-streams"));
          // Attendi un momento per permettere la chiusura degli altri stream
          setTimeout(() => {
            setShowVideo(true);
          }, 100);
        }
      }
    };
    
    initializeAlarm();
    alarmTimeoutOff();
    document.addEventListener("all-alarm-silence", silence);
    document.addEventListener("close-all-video-streams", closeVideoStream);
    return () => {
      if (alarmHandle) {
        clearTimeout(alarmHandle);
      }
      document.removeEventListener("all-alarm-silence", silence);
      document.removeEventListener("close-all-video-streams", closeVideoStream);

      // disable outbound audio when destroy the card
      if (sentineId != -1) {
        audioUtil.closeDeviceMic(sentineId);
        audioUtil.disableAudioStream(sentineId);
      }

      dispatch(GenericActions.setVideoAudioOutput(-1));
      
      // Cleanup Blob URL quando componente si smonta
      if (sceneClipUrl) {
        URL.revokeObjectURL(sceneClipUrl);
      }
    };
  }, []);

  const canDisplay = () => {
    return alarms.length > 0;
  };

  const getSensorTileMap = () => {
    let sensorMap: IAlarmTileVoice[] = [
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "rumore").length > 0,
        type: "rumore",
      },
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "pesogr").length > 0,
        type: "pesogr",
      },
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "pesogr2").length > 0,
        type: "pesogr2",
      },
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "lidarSx").length > 0,
        type: "lidarSx",
      },
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "lidarDx").length > 0,
        type: "lidarDx",
      },
      {
        enabled:
          alarms.filter((x: IAlarm) => x.sensor.type === "door").length > 0,
        type: "door",
      },
    ];
    // PROVA sul sensore solo se tutti i suoi allarmi sono di prova: un allarme vero non resta mai nascosto
    return sensorMap.map((x: IAlarmTileVoice) => {
      const ofType = alarms.filter((y: IAlarm) => y.sensor.type === x.type);
      return {
        ...x,
        isTest: ofType.length > 0 && ofType.every((y: IAlarm) => isTestAlarm(y)),
      };
    });
  };

  // tutti gli allarmi della finestra sono di prova
  const allTest = () => {
    return alarms.length > 0 && alarms.every((x: IAlarm) => isTestAlarm(x));
  };
  const someTest = () => {
    return alarms.some((x: IAlarm) => isTestAlarm(x));
  };

  const hasCameraConfigured = () => {
    return alarms[0]?.sensor?.sentinel?.cameraUrl && 
           alarms[0].sensor.sentinel.cameraUrl.trim() !== "";
  };

  const shouldShowRoomColumn = () => {
    const room = alarms[0]?.sensor?.sentinel?.patient?.room;
    // Nascondi la colonna se room è "0", null, undefined o stringa vuota
    return room && room !== "0" && String(room).trim() !== "";
  };

  return (
    <div
      style={{ display: "inline-block" }}
      className="fill-width-on-small-screen center-content-on-small-screen"
    >
      {canDisplay() && (
        <div
          className="alarms-gallery-modal"
          style={alarmBorder ? {} : { background: "url('./assets/alarm.jpg')" }}
        >
          <div className="alarms-gallery-modal-inner">
            <ReactHowler src="./assets/alarm.wav" playing={playSound} loop />
            <div className="alarms-gallery-modal-header">
              <div className="alarms-gallery-modal-header-left">
                <div className="alarms-gallery-modal-header-title">
                  ALLARME{" "}
                  {allTest() && (
                    <TestBadge title="Allarme di prova lanciato da Setup: va gestito come gli altri" />
                  )}
                  {!allTest() && someTest() && (
                    <TestBadge title="Insieme ad allarmi veri c'è anche un allarme di prova: guarda i sensori" />
                  )}
                </div>
                <div className="alarms-gallery-modal-header-date">
                  {formatDate()}
                </div>
              </div>
              <div className="alarms-gallery-modal-header-buttons">
                <div>
                  <IconButtonItem
                    iconName="VolumeDisabled"
                    disabled={!playSound}
                    tooltip="Muta allarme"
                    onClick={() => {
                      setPlaySound(false);
                      // Salva tutti gli allarmi come mutati in localStorage
                      alarms.forEach((alarm: IAlarm) => {
                        saveMutedAlarm(alarm.id);
                      });
                    }}
                  />
                </div>
                {hasCameraConfigured() && (
                  <div style={{ width: "3em" }} className="center-content">
                    <TooltipHost content={showVideo ? "Chiudi" : "Visualizza live"}>
                      <IconButton
                        iconProps={{ iconName: "Video" }}
                        className={showVideo ? "video-active" : "video-inactive"}
                        onClick={() => {
                          if (showVideo) {
                            // Se il video è attivo, disabilitalo
                            setShowVideo(false);
                          } else {
                            // Chiudi altri stream video attivi
                            document.dispatchEvent(new Event("close-all-video-streams"));
                            // Attendi un momento per permettere la chiusura degli altri stream
                            setTimeout(() => {
                              setShowVideo(true);
                            }, 100);
                          }
                        }}
                      />
                    </TooltipHost>
                  </div>
                )}
                <WalkieTalkieControls
                  sentinelId={alarms[0].sensor.sentinel.id}
                  compactMode={true}
                  activatedBy="alarm"
                />
                <div style={{ marginLeft: "0.4em" }}>
                  <IconButtonItem
                    iconName="Settings"
                    tooltip="Configura Dispositivo"
                    onClick={() => {
                      navigate(
                        AppRoutes.APP_CONFIGURE_PAGE +
                          "?sentinelId=" +
                          alarms[0].sensor.sentinel.id
                      );
                      setTimeout(() => {
                        window.document.dispatchEvent(
                          new Event("reset-navigation")
                        );
                      }, 200);
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              {getSensorTileMap().map((x: IAlarmTileVoice, i: number) => {
                return (
                  <AlarmGallerySensorTile
                    key={i}
                    enabled={x.enabled}
                    type={x.type}
                    isTest={x.isTest}
                  />
                );
              })}
              {/* sotto gli allarmi di prova: chi l'ha lanciata, e che nessuno ha bisogno di aiuto */}
              {Array.from(
                new Set(alarms.filter((x: IAlarm) => isTestAlarm(x)).map((x: IAlarm) => testAlarmNote(x)))
              ).map((note: string, i: number) => (
                <div key={"test-note-" + i} className="gallery-test-note">
                  {note}
                </div>
              ))}
            </div>
            <table className="alarm-dialog-table-wrap">
              <thead>
                <tr>
                  <th title="Nome">Nome</th>
                  <th title="Zona">Zona</th>
                  {shouldShowRoomColumn() && (
                    <th title="Stanza">Stanza</th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <TooltipHost
                      content={alarms[0].sensor.sentinel.patient.identifier}
                      id={alarms[0].id + "_alarm_dialog_1"}
                    >
                      <span>
                        {alarms[0].sensor.sentinel.patient.identifier}
                      </span>
                    </TooltipHost>
                  </td>
                  <td>
                    <TooltipHost
                      content={
                        <div>
                          {String(
                            alarms[0].sensor.sentinel.patient.floor
                          ).padStart(2, "0")}
                        </div>
                      }
                      id={alarms[0].id + "_alarm_dialog_2"}
                    >
                      {String(alarms[0].sensor.sentinel.patient.floor).padStart(
                        2,
                        "0"
                      )}
                    </TooltipHost>
                  </td>
                  {shouldShowRoomColumn() && (
                    <td>
                      <TooltipHost
                        content={
                          <div>
                            {String(
                              alarms[0].sensor.sentinel.patient.room
                            ).padStart(2, "0")}
                          </div>
                        }
                        id={alarms[0].id + "_alarm_dialog_3"}
                      >
                        {String(alarms[0].sensor.sentinel.patient.room).padStart(
                          2,
                          "0"
                        )}
                      </TooltipHost>
                    </td>
                  )}
                  {false && (
                    <td>
                      <TooltipHost
                        content={
                          <div>
                            {String(
                              alarms[0].sensor.sentinel.patient.bed
                            ).padStart(2, "0")}
                          </div>
                        }
                        id={alarms[0].id + "_alarm_dialog_4"}
                      >
                        {String(alarms[0].sensor.sentinel.patient.bed).padStart(
                          2,
                          "0"
                        )}
                      </TooltipHost>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
            {hasCameraConfigured() && (
              <div className="gallery-video-frame-wrap">
                {loadingScene ? (
                  // LOADER durante caricamento scena
                  <div
                    style={{
                      width: SettingsUtil.GetSettings("w_video_d", DEFAULT_VIDEO_SIZES[2]) + "px",
                      height: SettingsUtil.GetSettings("h_video_d", DEFAULT_VIDEO_SIZES[3]) + "px",
                      position: "relative"
                    }}
                  >
                    <div className="video-frame-loader-overlay">
                      <div className="video-frame-loader-content">
                        <div className="video-frame-spinner"></div>
                        <div className="video-frame-cam-label">
                          Caricamento scena...
                        </div>
                      </div>
                    </div>
                  </div>
                ) : showVideo ? (
                  sceneMode && sceneClipUrl ? (
                    // MODALITÀ SCENA: Player HTML5 per clip registrato con streaming progressivo
                    <video 
                      controls 
                      autoPlay
                      preload="metadata"
                      style={{
                        width: SettingsUtil.GetSettings("w_video_d", DEFAULT_VIDEO_SIZES[2]) + "px",
                        height: SettingsUtil.GetSettings("h_video_d", DEFAULT_VIDEO_SIZES[3]) + "px",
                        background: "#000",
                        borderRadius: "4px"
                      }}
                      src={sceneClipUrl}
                    >
                      Il tuo browser non supporta il tag video HTML5.
                    </video>
                  ) : (
                    // MODALITÀ LIVE: VideoFrame per stream in tempo reale
                    <VideoFrame
                      sentinel={alarms[0].sensor.sentinel}
                      index={0}
                      width={
                        SettingsUtil.GetSettings(
                          "w_video_d",
                          DEFAULT_VIDEO_SIZES[2]
                        ) + "px"
                      }
                      height={
                        SettingsUtil.GetSettings(
                          "h_video_d",
                          DEFAULT_VIDEO_SIZES[3]
                        ) + "px"
                      }
                    />
                  )
                ) : (
                  // Placeholder sempre visibile quando video non è attivo
                  <div
                    className="video-placeholder"
                    style={{
                      width:
                        SettingsUtil.GetSettings(
                          "w_video_d",
                          DEFAULT_VIDEO_SIZES[2]
                        ) + "px",
                      height:
                        SettingsUtil.GetSettings(
                          "h_video_d",
                          DEFAULT_VIDEO_SIZES[3]
                        ) + "px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#2b2b2b",
                      border: "2px solid #555",
                      borderRadius: "4px",
                    }}
                  >
                    <Icon
                      iconName="VideoOff"
                      style={{ fontSize: "48px", color: "#888", marginBottom: "10px" }}
                    />
                    <div style={{ color: "#aaa", fontSize: "14px", textAlign: "center" }}>
                      {AppConfig.nvr.enableSceneClip ? (
                        <>
                          Clicca "Visualizza scena" per vedere la registrazione<br/>
                          o "Visualizza live" per lo stream in tempo reale
                        </>
                      ) : (
                        <>
                          Clicca "Visualizza live" per lo stream in tempo reale
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            <div style={{ marginTop: "0.5em" }}>
              <Dropdown
                onRenderOption={(o: any) => {
                  return (
                    <div className="gallery-drop-down-row">
                      <span className="gallery-drop-down-row-lable">
                        {o.text}
                      </span>
                      <span className="gallery-drop-down-row-small">
                        {o.small}
                      </span>
                    </div>
                  );
                }}
                placeholder="Seleziona giustificativo"
                onChange={(e: any, o: IDropdownOption | undefined) => {
                  if (o !== undefined) {
                    setRefertReason(o.key.toString());
                  }
                }}
                options={refertOptions.map(
                  (x: IAlarmRefertOption, i: number) => {
                    return {
                      key: x.label,
                      text: (i + 1).toString() + " - " + x.label,
                      small: x.small,
                    };
                  }
                )}
              />
            </div>
            <div className="gallery-modal-button-wrap" style={{ display: "flex", gap: "0.5em", marginTop: "0.5em" }}>
              {hasCameraConfigured() && AppConfig.nvr.enableSceneClip && (
                <PrimaryButton
                  disabled={loadingScene || processing}
                  style={{ flex: 1 }}
                  text={loadingScene ? "Caricamento..." : "Visualizza scena"}
                  iconProps={{ iconName: loadingScene ? "Sync" : "VideoSearch" }}
                  onClick={handleShowScene}
                />
              )}
              <PrimaryButton
                disabled={!refertReason || processing}
                style={{ flex: 1 }}
                text="Referta"
                onClick={() => {
                  if (refertReason) {
                    setProcessing(true);

                    // Chiudi canale audio prima di refertare
                    walkieTalkieTimer.stop();
                    audioUtil.closeDeviceMic(alarms[0].sensor.sentinel.id);
                    audioUtil.disableAudioStream(alarms[0].sensor.sentinel.id);
                    dispatch(WalkieTalkieActions.disableAllChannels());

                    [...alarms]
                      .filter((x: IAlarm) => x.served !== true)
                      .forEach((item: IAlarm, i) => {
                        ApiService.AlarmsController.ManageAlarms(
                          item.id.toString(),
                          refertReason,
                          (response: IAPIResponse) => {
                            if (response.error == null) {
                              ToastMessage(
                                "success",
                                "Gestione allarme registrata: " +
                                  getSensorIconTooltip(item.sensor.type)
                              );
                              // Rimuovi l'allarme dalla lista dei mutati quando viene refertato
                              removeMutedAlarm(item.id);
                              props.onAlarmHandled(item.id);
                              document.dispatchEvent(
                                new Event("reload-all-alarms")
                              );
                            } else {
                              ToastMessage(
                                "error",
                                "Non è stato possibile registrare la gestione dell'allarme."
                              );
                            }
                            setProcessing(false);
                          }
                        );
                      });
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const AlarmGalleryHandler = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [newAlarms, setNewAlarms] = useState<IAlarm[]>([]);
  const [denyPopups, setDenyPopups] = useState<boolean>(false);
  const loggedUser = useSelector((s: GlobalState) => s.generic.user);
  // ⚠️ FIX CRITICO: useRef per evitare loop multipli sovrapposti (Code:181225)
  const alarmPollingTimeoutRef = useRef<number | null>(null);
  const isPollingActiveRef = useRef<boolean>(false);

  // const [sceneClipUrl, setSceneClipUrl] = useState<string | null>(null); //Fix Warning Complaint Code:071225
  // const [loadingScene, setLoadingScene] = useState<boolean>(false); //Fix Warning Complaint Code:071225
  // const [sceneMode, setSceneMode] = useState<boolean>(false); //Fix Warning Complaint Code:071225

  // ⚠️ REFACTORING: Separazione tra chiamata API e loop (come in AppLayout) Code:131225
  //  const pollNewAlarms = () => { //Code:131225
  const loadAlarmsNow = () => {
    let flagDiv = document.getElementById("gallery-handler-main-div");
    const sessionToken = localStorage.getItem("sessionToken");

    // Verifica che l'utente sia ancora loggato e che ci sia un token valido
    if (!loggedUser || !sessionToken) {    
      console.log("Polling allarmi fermato: utente non loggato o token mancante");
      return;
    }

    // Verifica che non siamo sulla pagina di login
    if (window.location.pathname.includes(AppRoutes.APP_LOGIN_PAGE)) {
      console.log("Polling allarmi fermato: pagina di login");
      return;
    }

    if (
      loggedUser &&
      flagDiv &&
      devDisablePoll == false &&
      GetProcessParam("REACT_APP_ALLOW_NETWORK_SCAN") === "1"
    ) {
      ApiService.AlarmsController.GetNewAlarms((response: IAPIResponse) => {
        if (response.error === null) {
          let alarms: IAlarm[] = response.parsed ?? [];
          let currentAlamrms: IAlarm[] = [...newAlarms];

          // disable existing popups if the alarm is not active any more
          for (let i = 0; i < currentAlamrms.length; i++) {
            if (
              alarms.filter((x) => x.id == currentAlamrms[i].id).length == 0
            ) {
              currentAlamrms[i].served = true;
            }
          }

          // enable new popups for each alarm never seen before
          for (let i = 0; i < alarms.length; i++) {
            if (
              currentAlamrms.filter((x) => x.id == alarms[i].id).length == 0
            ) {
              currentAlamrms.push(alarms[i]);
            }
          }
          purgeServedAlarms(currentAlamrms);

          // Aggiorna i sentinels in Redux con i dati più recenti dai sensori degli allarmi
          if (alarms.length > 0) {
            dispatch(GenericActions.updateSentinelsFromAlarms(alarms) as any);
          }
        }
      });
    }
  };

  // ⚠️ FIX CRITICO: Loop ricorsivo con guard per evitare loop multipli (Code:181225)
  const loopLoadAlarms = () => {
    // 🛡️ GUARD: Previeni loop multipli sovrapposti
    if (isPollingActiveRef.current) {
      console.warn('⚠️ [AlarmGalleryHandler] Loop già attivo, skip creazione nuovo timeout');
      return;
    }

    // Cancella timeout precedente prima di crearne uno nuovo
    if (alarmPollingTimeoutRef.current !== null) {
      clearTimeout(alarmPollingTimeoutRef.current);
      alarmPollingTimeoutRef.current = null;
    }

    isPollingActiveRef.current = true;
    const interval = getAlarmPollingInterval();
    console.log(`🔄 [AlarmGalleryHandler] Avvio polling allarmi (intervallo: ${interval}ms)`);

    const timeoutId = setTimeout(() => {
      loadAlarmsNow();
      isPollingActiveRef.current = false; // Reset guard prima della ricorsione
      loopLoadAlarms(); // ⚠️ Ricorsione DENTRO il setTimeout
    }, interval) as unknown as number;
    
    alarmPollingTimeoutRef.current = timeoutId;
  };

  useEffect(() => {
    // Cleanup function per fermare il polling
    const stopAlarmPolling = () => {
      if (alarmPollingTimeoutRef.current !== null) {
        console.log('🛑 [AlarmGalleryHandler] Stop polling allarmi');
        clearTimeout(alarmPollingTimeoutRef.current);
        alarmPollingTimeoutRef.current = null;
        isPollingActiveRef.current = false;
      }
    };

    // ⚠️ FIX DEFINITIVO: Usa loggedUser !== undefined (come AppLayout)
    if (loggedUser !== undefined) {
      const sessionToken = localStorage.getItem("sessionToken");
      
      // 🔧 FIX CRITICO: Carica immediatamente gli allarmi esistenti al mount
      console.log('📥 [AlarmGalleryHandler] Caricamento iniziale allarmi...');
      loadAlarmsNow();
      
      // ⚠️ FIX: WebSocket viene gestito SOLO da AppLayout per evitare connessioni duplicate
      // Non connettiamo qui per evitare conflitti e riconnessioni continue
      console.log('🔌 [AlarmGalleryHandler] WebSocket gestito da AppLayout (no connessione duplicata)');
      
      // 🔄 HTTP Polling (se abilitato)
      if (isPollingEnabled()) {
        console.log(`🔄 [AlarmGalleryHandler] Avvio HTTP polling (intervallo: ${getAlarmPollingInterval()}ms)...`);
        loopLoadAlarms();
      } else {
        console.log('⚠️ [AlarmGalleryHandler] HTTP Polling disabilitato in configurazione');
      }

      // Listener per ricaricare allarmi quando arriva un nuovo allarme via WebSocket
      const handleReloadAlarms = () => {
        console.log('🔄 [AlarmGalleryHandler] Ricaricamento allarmi da evento...');
        loadAlarmsNow();
      };
      
      document.addEventListener('reload-all-alarms', handleReloadAlarms);

      return () => {
        document.removeEventListener('reload-all-alarms', handleReloadAlarms);
        
        // Cleanup WebSocket
        if (isWebSocketEnabled()) {
          console.log('🔌 [AlarmGalleryHandler] Disconnessione WebSocket...');
          WebSocketService.disconnect();
        }
        
        // Cleanup Polling
        if (isPollingEnabled()) {
          console.log('🔄 [AlarmGalleryHandler] Stop HTTP polling...');
          stopAlarmPolling();
        }
      };
    } else {
      // Se l'utente non è loggato, ferma il polling
      stopAlarmPolling();
    }
  }, [loggedUser]);

  useEffect(() => {
    setDenyPopups(
      window.location.pathname.includes(AppRoutes.APP_OPTIONS_PAGE) ||
        window.location.pathname.includes(AppRoutes.APP_CONFIGURE_PAGE) ||
        window.location.pathname.includes(AppRoutes.APP_SETUP_PAGE) ||
        window.location.pathname.includes(AppRoutes.APP_CLINICAL_RECORD_PAGE)
    );
  }, [location]);

  const aggregateAlarmsByPatient = (alarms: IAlarm[]) => {
    let aggregatedAlarms: any = {};
    for (let i = 0; i < alarms.length; i++) {
      let alarm = alarms[i];
      let key = alarm.sensor.sentinel.patientId.toString();
      if (!aggregatedAlarms.hasOwnProperty(key)) {
        aggregatedAlarms[key] = [];
      }
      aggregatedAlarms[key].push(alarm);
    }
    return aggregatedAlarms;
  };

  let aggregatedAlarms: IAlarm[][] = Object.values(
    aggregateAlarmsByPatient([...newAlarms])
  );

  const alarmsNeedServing = (aggregatedAlarms: IAlarm[][]) => {
    for (let i = 0; i < aggregatedAlarms.length; i++) {
      let list: IAlarm[] = aggregatedAlarms[i];
      if (list.filter((x: any) => x.served !== true).length > 0) {
        return true;
      }
    }
    return false;
  };

  const onAlarmHandled = (alarmId: number) => {
    let alarms: IAlarm[] = [...newAlarms];
    for (let i = 0; i < alarms.length; i++) {
      if (alarms[i].id == alarmId) {
        alarms[i].served = true;
      }
    }
    purgeServedAlarms(alarms);
  };

  const purgeServedAlarms = (alarms: IAlarm[]) => {
    let aggregatedAlarms: any = aggregateAlarmsByPatient(alarms);
    let keys: string[] = Object.keys(aggregatedAlarms);
    let patientsToPurge: number[] = [];
    for (let i = 0; i < keys.length; i++) {
      let values: IAlarm[] = aggregatedAlarms[keys[i]];

      // if they are all served for this patient
      if (values.filter((x: IAlarm) => x.served !== true).length === 0) {
        // then remove their record from the master list
        patientsToPurge.push(+keys[i]);
      }
    }
    purgeAlarmsByPatientId(alarms, patientsToPurge);
  };

  const purgeAlarmsByPatientId = (
    alarms: IAlarm[],
    patientIdsToRemove: number[]
  ) => {
    let alarmsNew = [];
    for (let i = 0; i < alarms.length; i++) {
      if (
        patientIdsToRemove.indexOf(alarms[i].sensor.sentinel.patientId) === -1
      ) {
        alarmsNew.push(alarms[i]);
      }
    }
    setNewAlarms(alarmsNew);
  };

  return (
    <div id="gallery-handler-main-div">
      {!denyPopups && alarmsNeedServing(aggregatedAlarms) && (
        <div className="alarm-gallery-modal-wrap">
          {aggregatedAlarms.map((x: IAlarm[], i: number) => {
            return (
              <AlarmGalleryModal
                key={i}
                onAlarmHandled={onAlarmHandled}
                alarms={x}
                isFirstAlarm={i === 0}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AlarmGalleryHandler;
